// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionShopNow_root__2IMHp","title":"SectionShopNow_title__1xaHM","shopNow":"SectionShopNow_shopNow__2J6dh","shopNowLink":"SectionShopNow_shopNowLink__2ct9B"};